// src/pages/PartnersPage.jsx
import React, { useEffect, useState } from "react";
import "../styles/partners.css";

export default function PartnersPage({ data: outerData }) {
  const [innerData, setInnerData] = useState(null);
  const data = outerData || innerData;

  useEffect(() => {
    if (outerData) return;
    (async () => {
      const res = await fetch("/content.json", { cache: "no-cache" });
      const json = await res.json();
      setInnerData(json);
    })().catch(console.error);
  }, [outerData]);

  if (!data) return null;

  const partners = data?.partners || [];

  return (
    <div className="partners-page">
      {/* ✅ 히어로/탭은 AboutLayout이 렌더링하므로 여기선 제외 */}

      {/* 본문 */}
      <section className="partners-section">
        <div className="container">
          <div className="partners-header">
            <h2>함께하는 파트너사</h2>
            <p>다이빙이지는 다이빙 전문 업체뿐 아니라 다양한 분야의 파트너들과 함께합니다.</p>
          </div>

          <div className="partners-grid">
            {partners.map((p, i) => (
              <article key={i} className="partner-card" aria-label={p.name}>
                <div className="logo-wrap">
                  {/* 이미지만 표시 (텍스트/이름 미표시) */}
                  {p.image ? (
                    <img src={p.image} alt={p.name} />
                  ) : (
                    /* 이미지가 없을 때도 레이아웃 깨짐 방지를 위해 간단한 플레이스홀더 */
                    <img
                      src="data:image/svg+xml;utf8,\
                      <svg xmlns='http://www.w3.org/2000/svg' width='300' height='150'>\
                        <rect width='100%' height='100%' fill='%23eef2f7'/>\
                        <text x='50%' y='50%' dominant-baseline='middle' text-anchor='middle' fill='%2394a3b8' font-size='16' font-family='sans-serif'>NO IMAGE</text>\
                      </svg>"
                      alt="no logo"
                    />
                  )}
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
